import StoredLayout from '../../layouts/StoredLayout'
import Modals from './Modals'
export default StoredLayout(Modals)
